import { AppRoutes } from "./app_routes";

type AuthRoute = {
  path: string;
  element: React.ReactNode;
};

export const authRoutes: AuthRoute[] = [];

const publicPaths = [
  AppRoutes.LOGIN,
  AppRoutes.CREATE_ACCOUNT,
  AppRoutes.RESET_PASSWORD,
  AppRoutes.FORGOT_PASSWORD,
  AppRoutes.INDEX,
  AppRoutes.TERMS_AND_CONDITIONS,
  AppRoutes.PRIVACY_POLICY,
  AppRoutes.RETURN_POLICY,
];

export const isPublicPath = (path: string): boolean => {
  // Remove any query parameters
  const pathWithoutQuery = path.split("?")[0];
  // Exact match for most routes; CREATE_ACCOUNT also covers its nested wizard steps.
  if (pathWithoutQuery.startsWith(`${AppRoutes.CREATE_ACCOUNT}/`)) return true;
  return publicPaths.some((route) => pathWithoutQuery === route);
};
